/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Bharat Vora",
  title: "Hi all, I'm Bharat",
  subTitle: emoji(
    "With 3+ years of experience in Software and Full Stack Development, a strong foundation in Python, React, Django, Flask, AWS, and Heroku, and a passion for solving complex problems. I've also demonstrated leadership skills through coding clubs and a track record of success in national and international Hackathons.  💯😃"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1wMFuLo89LZcFayT-AoIrpxge0odOndUn/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  gmail: "bharatvora814@gmail.com",
  linkedin: "https://www.linkedin.com/in/bharat1510/",
  github: "https://github.com/bharat1510",
  stackoverflow: "https://stackoverflow.com/users/12929650/bharat-vora",
  medium: "https://bharat1510.medium.com/",
  blogger: "http://bharatvora814.blogspot.com/",
  // facebook: "https://www.facebook.com/bharat.vora.969",
  // twitter: "https://twitter.com/bharatvora814",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "Passionate full-stack developer with an insatiable curiosity to explore every tech stack -",
  skills: [
    emoji(
      "⚡ Expertise in developing highly interactive front-end and user interfaces for web and mobile applications"
    ),
    emoji("⚡ Building robust backends utilizing cutting-edge technology"),
    emoji("⚡ Ensuring data security with secure databases"),
    emoji("⚡ Proficiency in deploying cloud solutions"),
    emoji("⚡ Seamless integration of third-party services")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Django",
      fontAwesomeClassname: "devicon-django-plain"
    },
    {
      skillName: "Flask",
      fontAwesomeClassname: "devicon-flask-original"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "devicon-cplusplus-plain"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    

    { skillName: "", fontAwesomeClassname: "" },


    {
      skillName: "ReactJs",
      fontAwesomeClassname: "fab fa-react"
    },
    // {
    //   skillName: "NodeJs",
    //   fontAwesomeClassname: "fab fa-node"
    // },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "devicon-bootstrap-plain"
    },
    {
      skillName: "jQuery",
      fontAwesomeClassname: "devicon-jquery-plain"
    },


    { skillName: "", fontAwesomeClassname: "" },


    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Heroku",
      fontAwesomeClassname: "devicon-heroku-original"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "devicon-azure-plain"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "devicon-git-plain"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "devicon-kubernetes-plain"
    },
    {
      skillName: "Ansible",
      fontAwesomeClassname: "devicon-ansible-plain"
    },
    {
      skillName: "Terraform",
      fontAwesomeClassname: "devicon-terraform-plain"
    },
    {
      skillName: "Jira",
      fontAwesomeClassname: "fab fa-jira"
    },
    // {
    //   skillName: "Jenkins",
    //   fontAwesomeClassname: "devicon-jenkins-line"
    // },
    

    { skillName: "", fontAwesomeClassname: "" },


    {
      skillName: "SQL Database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "devicon-mysql-plain"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "devicon-postgresql-plain"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "devicon-mongodb-plain"
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section
const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Lambton College",
      logo: require("./assets/images/lambton.png"),
      subHeader: "Post Graduate Certificate",
      duration: "Jan 2022 - August 2023",
      desc: "GPA - 3.30 / 4",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Gujarat Technological University",
      logo: require("./assets/images/gtu.png"),
      subHeader: "Bachelor of Engineering in Computer Engineering",
      duration: "August 2016 - August 2020",
      desc: "CGPA - 8.4 / 10"
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience
const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend",
      progressPercentage: "90%"
    },
    {
      Stack: "Databases",
      progressPercentage: "95%"
    },
    {
      Stack: "Cloud & Devops",
      progressPercentage: "90%"
    },
    {
      Stack: "Graphics & Designing",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section
const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Global Surface Inc.",
      companylogo: require("./assets/images/globalsurface.jpeg"),
      date: "May 2023 – Present",
      desc: "",
      // desc: "Developed Web application backend using Python (Django) and UI components using React",
      descBullets: [
        "Integrate website analytics and Google Analytics data with inventory data for comprehensive analysis on an admindashboard.",
        "Built an employee management system module into the dashboard with five features, enhancing efficiency and productivity.",
        "Use Amazon Web Services, especially EC2, S3, and Beanstalk, to host applications with Docker containers.",
        "Developer more than 150 APIs in Django framework for React Js web application.",
        "Built 5 ETL Pipelines using Heroku Data Factory and crafted five database schema.",
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Global Surface Inc.",
      companylogo: require("./assets/images/globalsurface.jpeg"),
      date: "Apr 2022 – April 2023",
      desc: "",
      descBullets: [
        "Spearheaded end-to-end development of a robust Python (Django) web application, driving a 30% improvement in user experience and a 20% boost in site responsiveness.",
        "Conceptualized and designed innovative home tile decoration concepts, enhancing customer engagement by delivering a 15% increase in website dwell time and a 25% rise in product inquiries.",
        "Maximized user experience for 100K+ visitors by seamlessly hosting applications on AWS service, EC2 to reducing downtime by 40%.", 
        "Achieved 95% fewer critical API errors through meticulous Postman analysis and Unit Testing, ensuring data accuracy.",
      ]
    },
    {
      role: "Associate Software Engineer",
      company: "Accenture",
      companylogo: require("./assets/images/accenture.png"),
      date: "March 2021 – April 2022",
      // desc: "Developed microservices using Python, REST APIs using Java and Object detection model using tensorflow.",
      descBullets: [
        "Served as a backend developer to build a robust web application in Python web framework(Flask).",
        "Communicated with clients from the USA and Japan to provide backend support for over a period of 3 months.",
        "Employed Postman and analyzed more than 20 server APIs through comprehensive unit testing.",
        "Underwent 200+ hours of Agile Methodologies training for enhanced teamwork and development, alongside 300+ hours of trainingin cutting-edge technologies from Accenture's certified trainer.",
        "Wrote clean and quality code by appropriately incorporating the design pattern when needed.",
        "Troubleshooting the code, CI/CD pipelines, and Docker containers",
        "Writing Unit test, building CI/CD, Code Review, following Agile, using Docker for easy deployment and Git."
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Lionheart Apps (OPC) Pvt. Ltd.",
      companylogo: require("./assets/images/lionheart.png"),
      date: "February 2021 – June 2021",
      // desc: "Developed websites and REST APIs using Laravel, and UI components using Angular",
      descBullets: [
        "Facilitated the full stack technologies to design and build web and mobile applications.", 
        "Designed and created 15+ mailing templates using Adobe Photoshop, ensuring each template was visually captivating and aligned with the intended communication goals.",
        "Implemented 100+ CRUD APIs, including third-party APIs such as MSG91, Twillo, Fast API, and OpenWeatherMap.",
        "Expertly configured hosting and servers, harnessing the power of both AWS and Heroku platforms.",
      ]
    },
    {
      role: "Micro-experience | Linux Core - Intern",
      company: "Crio.Do",
      companylogo: require("./assets/images/crio.png"),
      date: "January 2020 - March 2020",
      // desc: "Developed websites and REST APIs using Laravel, and UI components using Angular",
      descBullets: [
        "Proficiently utilized Linux as the core operating system in backend development across multiple domains, demonstrating in-depth knowledge of system configurations and management.",
        "Applied Linux expertise to develop backend solutions in various programming languages, including Java and Python, showcasing versatility in tech stacks.",
        "Designed and implemented RESTful APIs, leveraging Linux's stability and security to ensure seamless communication between front-end and back-end systems.",
        "Successfully crafted three Android applications, leveraging Linux-based development environments to create robust and efficient mobile solutions.",
      ]
    },
    {
      role: "Full Stack Developer | AWS - Intern",
      company: "The Sparks Foundation",
      companylogo: require("./assets/images/spark.png"),
      date: "February 2019 – April 2019",
      // desc: "Researched, designed and trained ML models",
      descBullets: [
        "Possess strong expertise in Amazon Web Services (AWS), demonstrating the ability to leverage cloud computing services for scalable and reliable web and mobile application development.",
        "Experience in integrating authentication and user login systems using RESTful APIs, ensuring secure and seamless user experiences in web and mobile applications.",
        "With skills in Android app development, I can create native mobile applications for the Android platform, expanding my versatility as a Full Stack Developer.",
        "Excel in web development, encompassing both front-end and back-end technologies, allowing me to build end-to-end solutions that deliver excellent user experiences on the web.",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on
const bigProjects = {
  title: "Projects",
  subtitle: "Exploring innovation through personal and college projects.",
  projects: [
    {
      image: require("./assets/images/projects/analytics.png"),
      projectName: "Admin Analytic Dashboard",
      projectDesc:
        "Empowering Data Visualization and Secure Employee Access Solutionss",
      projectTechStack:
        "Tech Stack: Python, Django, React, Redux, MongoDB, Material, AWS, GraphQL",
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "http://saayahealth.com/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/smartmeeting.png"),
      projectName: "Smart Meeting",
      projectDesc:
        "Developed a Cutting-Edge Meeting Summarization Platform by Unlocking the Power of Automated Meeting Insights",
      projectTechStack:
        "Tech Stack: Python, Django, React, LSA, NLP, ML, CI/CD, Docker, Jira"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "http://saayahealth.com/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/web-scrapping.png"),
      projectName: "Amazon Web Scrapping",
      projectDesc:
        "Web scraping application seamlessly retrieves real-time product information from Amazon, categorizing it for an enriched online shopping experience.",
      projectTechStack:
        "Tech Stack: Beautiful soup, django, html, css, bootstrap"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "https://github.com/bharat1510/web-scrapping-application"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/image-caption.png"),
      projectName: "Image Caption Generating",
      projectDesc:
        "Image caption generation project that uses the power of AI to provide context and meaning to images.",
      projectTechStack: "Tech Stack: Image processing, NLP, Convolutional Neural Networks, Text Processing, Python, Django"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "https://github.com/bharat1510/Image-Caption-Generator-Tool"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/ayushman.png"),
      projectName: "Ayushman",
      projectDesc:
        "A web-application for automatically extracting the information from the health card and creating card with new format",
      projectTechStack: "Tech Stack: Python, Django, React, MySQL, Docker"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "http://saayahealth.com/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/robot.png"),
      projectName: "The Wireless Agriculture Robot",
      projectDesc:
        "A constructed wireless robot which can be controlled over the internet, also can work autonomously, detect, and identify diseases inthe plant.",
      projectTechStack: "Tech Stack: Faster R-CNN, OpenCV, Tensorflow, Arduino, Raspberry Pie, GSM Module, Hardware Components, Djnago, Python",
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "http://saayahealth.com/"
      //   },
      //   //  you can add extra buttons here.
      //   {
      //     name: "Prototype",
      //     url: "https://youtu.be/6L3dlKWy9J8?si=5r7vrWGOM0lODJZY",
      //   },
      // ]
    },
    {
      image: require("./assets/images/projects/qreward.png"),
      projectName: "Quarantine Reward",
      projectDesc:
        "The Web application offering a range of activities including games and exercises to keep citizens entertained and motivated at home, having a reward system, allowing users to earn and redeem money in their Paytm wallets.",
      projectTechStack: "Tech Stack: Keras, Tensorflow, Flask, Python, Web Technologies, MySQL, Heroku"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "https://github.com/bharat1510/qreward"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/rivermonitor.png"),
      projectName: "River Monitoring System",
      projectDesc:
        "Developed a customized sensor node system to monitor critical river water parameters, including pH, turbidity, temperature, and many more. Our solution extends to tracking industrial and hospital waste levels. ",
      projectTechStack: "Tech Stack: Random Forest, Machine Learning, Python, Web Technologies, Various sensors, Hardware component"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "http://saayahealth.com/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/commuters.png"),
      projectName: "Commuters Guide",
      projectDesc:
        "Innovative web application empowers users to effortlessly discover the quickest, most efficient, and optimal routes for their journeys. Additionally, users can create personalized events, enabling convenient travel planning.",
      projectTechStack: "Tech Stack: Java (JSP), MySQL, Web Technologies, Bootstrap"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "https://github.com/bharat1510/Commuters-Guide"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/projects/qrcode.png"),
      projectName: "QR & Bar Code Generator",
      projectDesc:
        "A user-friendly web app that simplifies the creation of QR codes and barcodes and effortlessly generate, customize, and deploy these codes for a wide range of applications.",
      projectTechStack: "Tech Stack: Django, Web Technologies, Ajax, Bootstrap"
      // footerLink: [
      //   {
      //     name: "GitHub",
      //     url: "http://saayahealth.com/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};


// Certificate Section
const certificateSection = {
  title: emoji("Certifications 📜 "),
  subtitle:
    "Explore my certificate section to witness the tangible evidence of my dedication and accomplishments.",

  certificateCards: [
    {
      title: "Agile Methodologies",
      subtitle:
        "Completed Agile methodologies certification with more than 70% from Accenture myLearning platform.",
      image: require("./assets/images/certificate/accenture.png"),
      imageAlt: "Agile Methodologies by Accenture - Bharat L. Vora",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/1paMJCKT419aq0ZFyRtxLU2Wj4CcRhHSB/view"
        // }
      ]
    },
    {
      title: "AWS Fundamentals Specialization",
      subtitle: "Learned the Amazon Web Services (AWS) cloud ecosystem, including core AWS services and key AWS security concepts. Alos covered fundamental strategies for planning and migrating existing workloads to AWS and how to build and deploy serverless applications with AWS.",
      image: require("./assets/images/certificate/aws.png"),
      imageAlt: "AWS Fundamentals Specialization by Amazon Web Services",
      footerLink: [
        {
          name: "Certification",
          url: "https://coursera.org/share/4feb3bc2b6f94bfc5bc52476c0b74465"
        }
      ]
    },
    {
      title: "React - The Complete Guide",
      subtitle: "I have successfully earned the 'React - The Complete Guide' certificate from Udemy, showcasing my proficiency in React.js, a powerful JavaScript library renowned for its advanced features, including state management, hooks, context API, and routing for building dynamic and interactive web applications.",
      image: require("./assets/images/certificate/udemy.png"),
      imageAlt: "React - The Complete Guide by Udemy",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://coursera.org/share/079e10d9022b38dab492ec7af826f7fb"
        // }
      ]
    },
    {
      title: "Neural Network and Deep Learning",
      subtitle: "I completed the 'Neural Network and Deep Learning' course by deeplearning.ai, gaining expertise in Deep Learning, Artificial Neural Networks, Backpropagation, Python Programming, and Neural Network Architecture.",
      image: require("./assets/images/certificate/deeplearning.png"),
      imageAlt: "Neural Network and Deep Learning by deeplearning.ai",
      footerLink: [
        {
          name: "Certification",
          url: "https://coursera.org/share/079e10d9022b38dab492ec7af826f7fb"
        }
      ]
    },
    
    {
      title: "Introduction to Programming Using Python",
      subtitle: "I successfully earned the 'Introduction to Programming Using Python' certificate from Sololearn, showcasing proficiency in Python programming fundamentals, problem-solving skills, and a solid foundation to explore advanced Python features.",
      image: require("./assets/images/certificate/sololearn.png"),
      imageAlt: "Introduction to Programming Using Python by Sololearn",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1oKu7X0TDKLFug9XIoKf8fOLsuIN1FWwv/view?usp=sharing"
        }
      ]
    },
    {
      title: "Introduction to Artificial Intelligence by IBM",
      subtitle: "I've completed the 'Introduction to Artificial Intelligence' certificate by IBM, solidifying my skills in Data Science, Deep Learning, Artificial Intelligence (AI), and Machine Learning, equipping me for cutting-edge AI jobs.",
      image: require("./assets/images/certificate/ibm.png"),
      imageAlt: "Introduction to Artificial Intelligence by IBM",
      footerLink: [
        {
          name: "Certification",
          url: "https://coursera.org/share/9f8646cfbb231141e00a2863ae92ce43"
        }
      ]
    },
    {
      title: "Professional Cloud Developer (Udemy)",
      subtitle: "Acquired comprehensive expertise in cloud development, ensuring proficiency in cloud-native application design, deployment, and optimization.",
      image: require("./assets/images/certificate/udemy.png"),
      imageAlt: "Professional Cloud Developer (Udemy)",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1i57LEDH5zZbYui1Oa5-PMhCyiByvuEI-/view?usp=sharing"
        }
      ]
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
const achievementSection = {
  title: emoji("Achievements 🏆 "),
  subtitle:
    "Achievements and Award Letters that I have done.",

  achievementsCards: [
    {
      title: "Finalist of Smart India Hackathon",
      subtitle:
        "Secured the second position in the world's largest hackathon with the project 'The Wireless Agriculture Robot' and Provided a solution for the agriculture problem defined by the Government of Uttarakhand.",
      image: require("./assets/images/achievements/sih.png"),
      imageAlt: "Finalist of Smart India Hackathon - Bharat L. Vora",
      footerLink: [
        {
          name: "Website",
          url: "https://sih.gov.in/"
        }
      ]
    },
    {
      title: "Innovative Student Startups - Winner",
      subtitle: "Participated in the college-level startup competition, Innovative Startups, and secured the first position, Honored by the CEO of NINVentures, USA.",
      image: require("./assets/images/achievements/gcet.png"),
      imageAlt: "Innovative Student Startups - Winner - Bharat L. Vora",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1xx0NIYMaQLbt12WWvRU0wr4S6cgi4EKt/view?usp=sharing"
        }
      ]
    },
    {
      title: "Student Startup Innovation Program (SSIP)",
      subtitle: "Received a grant of 11,000 INR from the Government of Gujarat for a final-year project and continuous support from industry mentors and Government officers.",
      image: require("./assets/images/achievements/ssip.png"),
      imageAlt: "Student Startup Innovation Program (SSIP) - Bharat L. Vora",
      footerLink: [
        {
          name: "Website",
          url: "https://www.ssipgujarat.in/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section
const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/coding-blocks/deploying-django-application-on-heroku-e78a82c9350a",
      title: "Deploying Django Application on Heroku",
      description:
        "How to deploy the Django application on the Heroku platform with PostgreSQL as a database."
    },
    {
      url: "https://bharatvora814.blogspot.com/2020/06/things-you-must-know-in-aws-amazon-web.html",
      title: "THINGS YOU MUST KNOW IN AWS (Amazon Web Service)",
      description:
        "Topics, features, and technology you need to know if you want to become an expert in AWS?"
    },
    {
      url: "https://bharatvora814.blogspot.com/2020/07/natural-language-processing-nlp.html",
      title: "Natural Language Processing (NLP) – Introduction, Applications, Useful Terms",
      description:
        "Topics, features, and technology you need to know if you want to become an expert in AWS?"
    },
    {
      url: "https://medium.com/coding-blocks/django-crud-api-with-postgresql-66d6377955a7",
      title: "Django CRUD API with PostgreSQL",
      description:
        "Build the Django application that uses the Django Rest Framework to build CRUD API with the PostgreSQL database."
    },
    {
      url: "https://bharatvora814.blogspot.com/2020/07/jwt-json-web-token-authentication.html",
      title: "JWT (JSON Web Token) Authentication",
      description:
        "Learn one of the best authentication techniques, JWT, and cover what is token-based authentication, why it is batter and more secure than password logins, and how it works?"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections
const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Hack LCIT",
      subtitle: "Proudly leading as the Head Organizer of Hack LCIT, the inaugural Lambton College Toronto Hackathon, driving innovation and fostering a dynamic environment for tech enthusiasts to showcase their creativity and problem-solving skills.",
      video_url: "https://www.instagram.com/reel/CpbG6BOATCJ/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
      event_url: "https://gdsc.community.dev/events/details/developer-student-clubs-lambton-college-toronto-presents-hack-lcit/",
      image: require("./assets/images/talks/hackLCIT.png"),
      imageAlt: "Image",
      date: "Mar 3 2023"
    },
    {
      title: "ASK GDSC",
      subtitle: "As GDSC President, I led a comprehensive Info Session at Lambton College, offering students vital insights into GDSC activities and upcoming opportunities.",
      video_url: "https://www.instagram.com/p/ClZWffpPoI_/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA==",
      event_url: "https://gdsc.community.dev/events/details/developer-student-clubs-lambton-college-toronto-presents-ask-gdsc/",
      image: require("./assets/images/talks/askME.png"),
      imageAlt: "Image",
      date: "Nov 24 2022"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Leaderships
const leadershipSection = {
  title: "LEADERSHIPS",
  subtitle: emoji(
    "Embracing the art of leadership, I sculpt opportunities and inspire change. 🕺"
  ),

  talks: [
    {
      title: "President - Google Developer Student Club",
      subtitle: "I had the privilege of serving as the President of the Google Developer Student Club at Lambton College, Toronto and build the first ever coding club in college.",
      organization_url: "https://gdsc.community.dev/",
    },
    {
      title: "Community Member of Google Developer Group",
      subtitle: "Proudly contributing as an active community member of the Google Developer Group, where innovation and collaboration thrive!",
      organization_url: "https://gdg.community.dev/",
    },
    {
      title: "Judge and Technical Mentor at nxHack",
      subtitle: "As a Judge and Technical Mentor at nxHack at the University of British Columbia, I had the incredible opportunity to witness innovation at its finest while guiding the next generation of tech visionaries.",
      organization_url: "https://2023.nwhacks.io/",
    },
    {
      title: "Technical Mentor at UofTHacks X",
      subtitle: "Proudly took on the role of Technical Mentor at UofTHacks X Hackathon, guiding future innovators at the University of Toronto towards their tech dreams.",
      organization_url: "https://www.uofthacks.com/",
    },
    {
      title: "Technical Mentor at Hack the North",
      subtitle: "As a Technical Mentor at Hack the North, I had the incredible opportunity to guide and collaborate with over 1500 brilliant hackers at the renowned University of Waterloo hackathon.",
      organization_url: "https://hackthenorth.com/",
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};


// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Whether you'd like to discuss a project, share ideas, or simply want to say hi, my inbox is always open for all! Feel free to reach out anytime. 😊📩",
  number: "+1 (289) 889-2452",
  email_address: "bharatvora814@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  certificateSection,
  blogSection,
  talkSection,
  leadershipSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
